<template>
  <vx-card>
    <template>
      <div class="vx-row">
        <div class="vx-col md:w-3/4 w-full">
          <h6 class="mb-2">Cliente</h6>
          <v-select
            name="cliente"
            v-validate="'required'"
            label="fantasia"
            v-model="data.cliente"
            :options="getCustomers">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('cliente')">{{ errors.first('cliente') }}</span>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Empresa</h6>
          <ul class="flex flex-wrap mt-4" style="align-items: center">
            <li>
              <vs-radio name="empresa" v-validate="'required'" class="mr-5" v-model="data.empresa" vs-value="1">Regnaparts</vs-radio>
            </li>
            <li>
              <vs-radio name="empresa" v-validate="'required'" class="mr-5" v-model="data.empresa" vs-value="2">Revestebem</vs-radio>
            </li>
          </ul>
          <span class="text-danger text-sm" v-show="errors.has('empresa')">{{ errors.first('empresa') }}</span>
        </div>
      </div>
      <br>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <h6 class="mb-2">Tipo de Cobrança</h6>
          <v-select name="tipoCobranca" v-validate="'required'" :options="tipoCobrancaOptions" v-model="data.tipoCobranca">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('tipoCobranca')">{{ errors.first('tipoCobranca') }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <template v-if="data.tipoCobranca">
            <div v-if="data.tipoCobranca == 'Boleto'">
              <h6 class="mb-2">Condição de Pagamento</h6>
              <vs-input name="boleto" v-validate="'required'" v-mask="'###/###/###/###/###/###/###'" class="w-full" key="boleto" v-model="data.opcaoBoleto" />
              <span class="text-danger text-sm" v-show="errors.has('boleto')">{{ errors.first('boleto') }}</span>
            </div>
            <div v-else-if="data.tipoCobranca == 'Cartão de Crédito'">
              <h6 class="mb-2">Número de Parcelas (máx. 6x)</h6>
              <vs-input name="cartaoCredito" v-validate="'required'" type="number" v-mask="cartaoCreditoMask" class="w-full" key="cartaoCredito" v-model="data.opcaoCredito" />
              <span class="text-danger text-sm" v-show="errors.has('cartaoCredito')">{{ errors.first('cartaoCredito') }}</span>
            </div>
            <div v-else>
              <h6 class="mb-2">Nenhuma opção disponível</h6>
              <vs-input class="w-full" disabled />
            </div>
          </template>
          <div v-else>
            <h6 class="mb-2">Nenhuma opção disponível</h6>
            <vs-input class="w-full" disabled />
          </div>
        </div>
      </div>
      <br>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <h6 class="mb-2">Transportadora</h6>
          <v-select
            name="transportadora"
            label="nomeCurto"
            v-validate="'required'"
            v-model="data.transportadora"
            :options="getCarriers">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('transportadora')">{{ errors.first('transportadora') }}</span>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Valor do Frete</h6>
          <vs-input name="valorFrete" v-validate="'required'" v-currency="currencyMaskOptions" class="w-full" v-model="data.valorFrete" />
          <span class="text-danger text-sm" v-show="errors.has('valorFrete')">{{ errors.first('valorFrete') }}</span>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Tipo</h6>
          <v-select
            name="tipoFrete"
            v-validate="'required'"
            v-model="data.tipoFrete"
            :options="tipoFreteOptions">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('tipoFrete')">{{ errors.first('tipoFrete') }}</span>
        </div>
      </div>
      <br>
      <div class="vx-row">
        <div class="vx-col md:w-1/6 w-full">
          <h6 class="mb-2">Volume</h6>
          <vs-input name="volume" type="number" v-validate="'required'" v-mask="'######'" class="w-full" v-model="data.volume" />
          <span class="text-danger text-sm" v-show="errors.has('volume')">{{ errors.first('volume') }}</span>
        </div>
        <div class="vx-col md:w-5/6 w-full">
          <h6 class="mb-2">Observações</h6>
          <vs-input class="w-full" v-model="data.observacoes" />
        </div>
      </div>
    </template>
    <br>
    <template>
      <NewQuoteSidebar
        :isSidebarActive="newQuoteSidebar"
        @productAdded="addProductToTable"
        @productEdited="productEdited"
        @closeSidebar="toggleDataSidebar"
        :data="{products: getProducts, productToEdit: getProductToEdit}" />
      <h4 class="mb-5">Itens de Venda</h4>
      <div class="flex flex-wrap-reverse items-center">
        <!-- ADD NEW -->
        <div @click="addNewData" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
          <feather-icon
            icon="PlusIcon"
            svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Novo</span>
        </div>
      </div>
      <vs-table ref="table" :max-items="1000" :noDataText="'Nenhum produto adicionado'" :data="addedProducts">
        <template slot="thead">
          <vs-th>Código</vs-th>
          <vs-th>Descrição</vs-th>
          <vs-th>Marca</vs-th>
          <vs-th>Modelo</vs-th>
          <vs-th>Quantidade</vs-th>
          <vs-th>Valor Unit.</vs-th>
          <vs-th>Valor Total</vs-th>
          <vs-th>Ações</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="addedProducts" :key="indextr" v-for="(product, indextr) in data">
              <vs-td>
                <p class="font-medium">{{ product.codigo }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.descricaoPTBR }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.marca }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.modelo }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.quantidade }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.valorUnitario }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ product.valorTotal }}</p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(product)" />
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="deleteData(product)" />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <div v-if="!(addedProducts).length">
        <vs-input name="jsonProdutos" v-model="jsonProdutosToValidate" v-validate="'required'" class="hidden w-full"></vs-input>
        <span class="text-danger text-sm" v-show="errors.has('jsonProdutos')">{{ errors.first('jsonProdutos') }}</span>
      </div>
    </template>
    <div class="flex flex-wrap items-center" slot="footer">
      <vs-button class="mr-6" @click="submitData()">Salvar</vs-button>
    </div>
  </vx-card>
</template>
<script>
import helpers from "@/helpers"
import axios from "axios"
import { baseApiUrl } from "@/global"
import NewQuoteSidebar from "./NewQuoteSidebar.vue";
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    cliente: { required: 'Selecione um cliente' },
    empresa: { required: 'Selecione uma empresa' },
    tipoCobranca: { required: 'Selecione um tipo de cobrança' },
    boleto: { required: 'Insira a condição de pagamento' },
    cartaoCredito: { required: 'Insira a quantidade de parcelas' },
    transportadora: { required: 'Selecione a transportadora' },
    valorFrete: { required: 'Insira o valor do frete' },
    tipoFrete: { required: 'Selecione o tipo do frete' },
    volume: { required: 'Selecione a quantidade de volumes' },
    jsonProdutos: { required: 'Selecione ao menos 1 produto' },
  }
};

Validator.localize('en', dict);


export default {
  data() {
    return {
      data: {},
      products: [],
      productToEdit: null,
      addedProducts: [],
      jsonProdutosToValidate: null,
      helpers: null,
      cartaoCreditoMask: {
        mask: '6',
        tokens: {
          '6': {
            pattern: /[1-6]/,
          }
        }
      },
      currencyMaskOptions: helpers.maskOptions.currency,
      newQuoteSidebar: false,
      tipoCobrancaOptions: ["Boleto", "À Vista", "Cartão de Crédito"],
      tipoFreteOptions: ["CIF", "FOB"],
    }
  },
  directives: helpers.directives,
  components: {
    NewQuoteSidebar,
  },
  computed: {
    getCustomers() {
      return this.$store.state.customers
    },
    getProducts() {
      return this.$store.state.products
    },
    getCarriers() {
      return this.$store.state.carriers
    },
    getProductToEdit() {
      return this.productToEdit
    },
  },
  methods: {
    addNewData() {
      this.toggleDataSidebar(true);
    },
    editData(data) {
      this.productToEdit = data
      this.toggleDataSidebar(true);
    },
    deleteData(data) {
      this.addedProducts = this.addedProducts.filter(el => !(el == data))
    },
    toggleDataSidebar(val = false) {
      this.newQuoteSidebar = val;
    },
    productEdited() {
      this.productToEdit = null
    },
    addProductToTable(productData) {
      this.addedProducts.push(productData)
    },
    async submitData() {
      let haveErrors = !(await this.$validator.validateAll())
      console.log(haveErrors);
      if (haveErrors)
        return
        
      if (this.data.tipoCobranca == 'Boleto')
        delete this.data.opcaoCredito
      if (this.data.tipoCobranca == 'Cartão de Crédito')
        delete this.data.opcaoBoleto

      for (let addedProduct of this.addedProducts) {
        addedProduct.valorUnitario = this.$parseCurrency(addedProduct.valorUnitario, this.currencyMaskOptions)
        addedProduct.valorTotal = this.$parseCurrency(addedProduct.valorTotal, this.currencyMaskOptions)
      }
      let formData = {
        fk_IdWebMaisCli: this.data.cliente.IdWebMaisCli,
        fk_idEmpresa: this.data.empresa,
        fk_idTransportadora: this.data.transportadora.idTransportadora,
        criadoPor: this.$store.state.user.idUser,
        criadoEm: this.helpers.dateHelper.getDateTimeToSql(),
        opcaoPagamento: this.data.opcaoBoleto || this.data.opcaoCredito,
        tipoCobranca: this.data.tipoCobranca,
        valorFrete: this.$parseCurrency(this.data.valorFrete, this.currencyMaskOptions),
        tipoFrete: this.data.tipoFrete,
        observacoes: this.data.observacoes,
        volume: this.data.volume,
        jsonProdutos: JSON.stringify(this.addedProducts)
      }

      try {
        this.$vs.loading()
        await axios.post(`${baseApiUrl}/quote/insert`, formData)
        this.$router.push({ name: 'quote-list' })

      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar: " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  created() {
    this.helpers = helpers
    const payload = {
      loading: this.$vs.loading
    }
    this.$store.dispatch("fetchCustomersItems", payload)
    this.$store.dispatch("fetchProductsItems", payload)
    this.$store.dispatch("fetchCarriersItems", payload)
  }

}

</script>
